import {
  ACCEPT_SHIFT_REQUEST,
  ACCEPT_SHIFT_REQUEST_FAIL,
  ACCEPT_SHIFT_REQUEST_SUCCESS,
  ADD_OPEN_SHIFT,
  ADD_OPEN_SHIFT_FAIL,
  ADD_OPEN_SHIFT_SUCCESS,
  DELETE_OPEN_SHIFTS,
  DELETE_OPEN_SHIFTS_FAIL,
  DELETE_OPEN_SHIFTS_SUCCESS,
  GET_OPEN_SHIFTS,
  GET_OPEN_SHIFTS_FAIL,
  GET_OPEN_SHIFTS_SUCCESS,
  OPEN_SHIFT_REQUEST_LIST,
  OPEN_SHIFT_REQUEST_LIST_FAIL,
  OPEN_SHIFT_REQUEST_LIST_SUCCESS,
  UPDATE_OPEN_SHIFT,
  UPDATE_OPEN_SHIFT_FAIL,
  UPDATE_OPEN_SHIFT_SUCCESS,
} from "./actionTypes";

export const deleteOpenShift = (data, syncList) => ({
  type: DELETE_OPEN_SHIFTS,
  payload: { data, syncList },
});

export const deleteOpenShiftSuccess = data => ({
  type: DELETE_OPEN_SHIFTS_SUCCESS,
  payload: data,
});

export const deleteOpenShiftFail = data => ({
  type: DELETE_OPEN_SHIFTS_FAIL,
  payload: data,
});

export const getOpenShifts = data => ({
  type: GET_OPEN_SHIFTS,
  payload: data,
});

export const getOpenShiftsSuccess = data => ({
  type: GET_OPEN_SHIFTS_SUCCESS,
  payload: data,
});

export const getOpenShiftsFail = data => ({
  type: GET_OPEN_SHIFTS_FAIL,
  payload: data,
});

export const openShiftRequestList = data => ({
  type: OPEN_SHIFT_REQUEST_LIST,
  payload: data,
});

export const openShiftRequestListSuccess = data => ({
  type: OPEN_SHIFT_REQUEST_LIST_SUCCESS,
  payload: data,
});

export const openShiftRequestListFail = data => ({
  type: OPEN_SHIFT_REQUEST_LIST_FAIL,
  payload: data,
});

export const acceptShiftRequest = (data, syncList) => ({
  type: ACCEPT_SHIFT_REQUEST,
  payload: { data, syncList },
});

export const acceptShiftRequestSuccess = data => ({
  type: ACCEPT_SHIFT_REQUEST_SUCCESS,
  payload: data,
});

export const acceptShiftRequestFail = data => ({
  type: ACCEPT_SHIFT_REQUEST_FAIL,
  payload: data,
});

export const addOpenShift = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_OPEN_SHIFT,
  payload: { data, onSuccess, onError },
});

export const addOpenShiftSuccess = data => ({
  type: ADD_OPEN_SHIFT_SUCCESS,
  payload: data,
});

export const addOpenShiftFail = data => ({
  type: ADD_OPEN_SHIFT_FAIL,
  payload: data,
});

export const updateOpenShift = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_OPEN_SHIFT,
  payload: { data, onSuccess, onError },
});

export const updateOpenShiftSuccess = data => ({
  type: UPDATE_OPEN_SHIFT_SUCCESS,
  payload: data,
});

export const updateOpenShiftFail = data => ({
  type: UPDATE_OPEN_SHIFT_FAIL,
  payload: data,
});
